import { render, staticRenderFns } from "./jzcg.vue?vue&type=template&id=22857d5c&scoped=true&"
import script from "./jzcg.vue?vue&type=script&lang=js&"
export * from "./jzcg.vue?vue&type=script&lang=js&"
import style0 from "./jzcg.vue?vue&type=style&index=0&id=22857d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22857d5c",
  null
  
)

export default component.exports